// appData.js - Sistema completo de datos multiidioma
export const appData = {
  languages: {
    es: {
      // Navegación principal
      navigation: {
        english: "Trivia",
        stories: "Historias",
        grammar: "Gramática",
        verbs: "Verbos",
        quiz: "Quiz",
        about: "Acerca de",
        portfolio: "Portfolio",
        contact: "Contacto"
      },

      // Sección English
      english: {
        title: "MEGA GUÍA DE GRAMÁTICA INGLÉS",
        subtitle: "Click en \"Ver más ejemplos\" para expandir cada tema",
        description: "¡Sigue practicando para dominar el inglés!",
        features: [
          "Gramática estructurada por categorías",
          "Lista completa de verbos irregulares",
          "Ejercicios interactivos",
          "Ejemplos prácticos",
          "Progreso personalizado"
        ],
        startButton: "Comenzar Curso",
        learnMoreButton: "Aprender Más"
      },

      // Sección Grammar
      grammar: {
        title: "Gramática Inglesa",
        subtitle: "Aprende las reglas fundamentales del inglés",
        description: "Explora diferentes categorías gramaticales con ejemplos prácticos y explicaciones claras.",
        searchPlaceholder: "Buscar tema gramatical...",
        noResultsFound: "No se encontraron resultados",
        examplesButton: "Ver Ejemplos",
        backButton: "Volver",
        examples: "Ejemplos"
      },

      // Sección Verbs
      verbs: {
        title: "Verbos Irregulares",
        subtitle: "Domina los verbos irregulares más importantes",
        description: "Lista completa de verbos irregulares con pronunciación y ejemplos de uso.",
        searchPlaceholder: "Buscar verbo...",
        headers: {
          infinitive: "Infinitivo",
          pastSimple: "Pasado Simple",
          pastParticiple: "Participio Pasado",
          translation: "Traducción"
        },
        showAll: "Mostrar Todos",
        showLess: "Mostrar Menos"
      },

      // Sección Quiz
      quiz: {
        title: "Prueba tus Conocimientos",
        subtitle: "Evalúa tu progreso con nuestros quizzes interactivos",
        description: "Pon a prueba lo que has aprendido con ejercicios de gramática y vocabulario.",
        startQuiz: "Iniciar Quiz",
        nextQuestion: "Siguiente Pregunta",
        previousQuestion: "Pregunta Anterior",
        finishQuiz: "Finalizar Quiz",
        restartQuiz: "Reiniciar Quiz",
        backToMenu: "Volver al Menú",
        question: "Pregunta",
        of: "de",
        score: "Puntuación",
        results: "Resultados",
        correct: "Correctas",
        incorrect: "Incorrectas",
        percentage: "Porcentaje",
        feedback: {
          excellent: "¡Excelente! Dominas muy bien el tema.",
          good: "¡Bien hecho! Vas por buen camino.",
          needsPractice: "Necesitas más práctica. ¡Sigue estudiando!",
          keepTrying: "¡No te rindas! La práctica hace al maestro."
        }
      },

      // Sección Stories
      stories: {
        title: "Mis Historias",
        subtitle: "Colección personal de relatos épicos y fantásticos",
        description: "Explora mundos de fantasía, romance y aventura creados con pasión",
        loading: "Cargando historias...",
        backToStories: "Volver a Historias",
        readStory: "Leer Historia",
        moreStories: "Más historias próximamente...",
        author: "Autor",
        status: "Estado",
        chapters: "Capítulos",
        tags: "Etiquetas",
        lastUpdated: "Última actualización",
        chapterEnd: "Fin del capítulo disponible",
        createdWithLove: "Historia creada con amor por",
        totalStories: "Total de historias",
        totalChapters: "Total de capítulos",
        statusOptions: {
          inProgress: "En progreso",
          completed: "Completa",
          draft: "Borrador"
        }
      },

      // Sección About
      about: {
        title: "Acerca del Proyecto",
        subtitle: "Desarrollador Full Stack y Creador de Aplicaciones Educativas",
        description: "Esta aplicación de gramática inglesa es uno de mis proyectos de desarrollo web, diseñado para demostrar mis habilidades en la creación de aplicaciones educativas interactivas. Como desarrollador freelance, me especializo en crear proyectos similares para clientes.",
        features: {
          title: "Características del Proyecto",
          items: [
            {
              title: "Desarrollo Full Stack",
              description: "Aplicación completa con React y funcionalidades avanzadas"
            },
            {
              title: "Interfaz Interactiva",
              description: "UI/UX moderna con componentes dinámicos y responsivos"
            },
            {
              title: "Funcionalidad Completa",
              description: "Sistema de quizzes, navegación intuitiva y gestión de datos"
            },
            {
              title: "Código Escalable",
              description: "Arquitectura modular y mantenible para futuras expansiones"
            }
          ]
        },
        objectives: {
          title: "Objetivos del Desarrollo",
          items: [
            "Demostrar capacidades de desarrollo en React y JavaScript",
            "Crear una experiencia de usuario excepcional",
            "Implementar funcionalidades educativas complejas",
            "Mostrar habilidades de diseño y arquitectura de software"
          ]
        },
        methodology: {
          title: "Proceso de Desarrollo",
          description: "Mi enfoque combina las mejores prácticas de desarrollo web moderno, utilizando tecnologías actuales y metodologías ágiles para crear proyectos robustos y escalables."
        }
      },

      // Sección Portfolio
      portfolio: {
        title: "Mi Portfolio",
        subtitle: "Conoce mi experiencia y proyectos",
        navigation: {
          home: "Inicio",
          about: "Acerca de",
          experience: "Experiencia", 
          projects: "Proyectos",
          services: "Servicios",
          skills: "Habilidades",
          contact: "Contacto"
        },
        hero: {
          greeting: "¡Hola! Soy",
          profession: "Desarrollador Full Stack | Especialista en Drupal",
          description: "Ingeniero de Sistemas con experiencia comprobada entregando proyectos exitosos para clientes en todo el mundo. Especializado en desarrollo Drupal para universidades, agencias digitales y organizaciones en Estados Unidos.",
          ctaButton: "Ver Proyectos",
          contactButton: "Contactar"
        },
        about: {
          title: "Sobre Mí",
          description: "Ingeniero de Sistemas con años de experiencia especializada en desarrollo Drupal. He construido y mantenido exitosamente soluciones web complejas para universidades, agencias digitales y diversas organizaciones. Mi experiencia técnica abarca múltiples frameworks como React, Angular, Node.js, WordPress y ASP.NET, pero Drupal sigue siendo una de mis fortalezas principales con profunda experiencia en desarrollo de módulos personalizados, tematización e implementaciones a nivel empresarial.",
          downloadCV: "Descargar CV",
          stats: {
            experience: "Años de Experiencia",
            projects: "Proyectos Completados",
            clients: "Clientes Satisfechos",
            technologies: "Tecnologías Dominadas"
          }
        },
        experience: {
          title: "Experiencia",
          subtitle: "Mi trayectoria profesional",
          workTab: "Trabajo",
          educationTab: "Educación",
          present: "Presente",
          achievements: "Logros"
        },
        projects: {
          title: "Proyectos",
          subtitle: "Algunos de mis trabajos destacados",
          viewProject: "Ver Proyecto",
          viewCode: "Ver Código",
          technologies: "Tecnologías",
          status: "Estado",
          type: "Tipo",
          showMore: "Ver todos los proyectos",
          showLess: "Mostrar menos",
          ctaTitle: "¿Tienes un proyecto en mente?",
          ctaDescription: "Me encantaría escuchar tu idea y ayudarte a hacerla realidad. ¡Trabajemos juntos!",
          contactButton: "Contactar"
        },
        services: {
          title: "Servicios",
          subtitle: "Soluciones profesionales para tu negocio",
          price: "Precio",
          deliveryTime: "Tiempo de Entrega",
          features: "Características",
          technologies: "Tecnologías",
          contactService: "Contactar",
          whatsappContact: "Contactar por WhatsApp"
        },
        skills: {
          title: "Habilidades",
          subtitle: "Tecnologías que domino",
          categories: {
            frontend: "Frontend",
            backend: "Backend", 
            database: "Base de Datos",
            tools: "Herramientas",
            design: "Diseño"
          }
        },
        contact: {
          title: "Contacto",
          subtitle: "¡Trabajemos juntos!",
          description: "¿Tienes un proyecto en mente? Me encantaría conocer tu idea y ayudarte a convertirla en realidad.",
          info: {
            title: "Información de Contacto",
            email: "Email",
            whatsapp: "WhatsApp",
            location: "Ubicación",
            availability: "Disponibilidad"
          },
          form: {
            title: "Envíame un mensaje",
            name: "Nombre",
            email: "Email",
            subject: "Asunto",
            message: "Mensaje",
            namePlaceholder: "Tu nombre",
            emailPlaceholder: "tu@email.com",
            messagePlaceholder: "Cuéntame sobre tu proyecto...",
            selectSubject: "Selecciona un asunto",
            subjects: {
              webDev: "Desarrollo Web",
              consulting: "Consultoría",
              collaboration: "Colaboración",
              other: "Otro"
            },
            sendButton: "Enviar por WhatsApp",
            required: "Campo requerido"
          },
          social: {
            title: "Redes Sociales",
            description: "Sígueme en mis redes sociales"
          },
          quickContact: {
            title: "¿Prefieres contacto directo?",
            whatsapp: "WhatsApp",
            email: "Email",
            emailSubject: "Consulta sobre servicios de desarrollo",
            whatsappMessage: "Hola! Estoy interesado en tus servicios de desarrollo web."
          },
          location: "Ubicación",
          email: "Email",
          services: {
            title: "Servicios Disponibles",
            items: [
              "Desarrollo Web Full Stack",
              "Aplicaciones React & Angular", 
              "Proyectos Laravel & ASP.NET",
              "Desarrollo WordPress & Drupal",
              "Plataformas Educativas",
              "Consultoría Técnica"
            ]
          }
        },
        nav: {
          home: "Inicio",
          about: "Acerca de",
          projects: "Proyectos",
          skills: "Habilidades",
          experience: "Experiencia",
          services: "Servicios",
          contact: "Contacto",
          portfolio: "Portfolio",
          company: "Empresa",
          englishCourse: "Curso de Inglés"
        },
        footer: {
          description: "Desarrollador Full-Stack especializado en crear experiencias web excepcionales. Transformo ideas en soluciones digitales innovadoras.",
          profession: "Desarrollador Full-Stack",
          follow: "Sígueme en",
          quickLinks: "Enlaces Rápidos",
          technicalConsulting: "Consultoría Técnica",
          rights: "Todos los derechos reservados",
          privacy: "Privacidad",
          terms: "Términos",
          cookies: "Cookies",
          builtWith: "Hecho con"
        },
        services: {
          title: "Servicios",
          subtitle: "¿En qué puedo ayudarte?",
          webDevelopment: "Desarrollo Web",
          frontend: "Desarrollo Frontend",
          backend: "Desarrollo Backend",
          fullstack: "Desarrollo Full-Stack",
          ecommerce: "E-commerce",
          features: "Incluye",
          technologies: "Tecnologías",
          contactService: "Contactar",
          deliveryTime: "Tiempo de Entrega"
        }
      },

      // Mensajes generales
      common: {
        loading: "Cargando...",
        error: "Error",
        success: "Éxito",
        cancel: "Cancelar",
        confirm: "Confirmar",
        close: "Cerrar",
        save: "Guardar",
        edit: "Editar",
        delete: "Eliminar",
        search: "Buscar",
        filter: "Filtrar",
        reset: "Reiniciar",
        showMore: "Mostrar más",
        showLess: "Mostrar menos",
        noResults: "No se encontraron resultados",
        tryAgain: "Intentar de nuevo"
      },

      // Autenticación
      auth: {
        title: "Acceso Restringido",
        subtitle: "Esta sección requiere autenticación para acceder",
        passwordLabel: "Contraseña:",
        passwordPlaceholder: "Ingresa la contraseña",
        submitButton: "Acceder",
        logoutButton: "Cerrar Sesión",
        incorrectPassword: "Contraseña incorrecta",
        privateSection: "Sección privada para uso personal"
      }
    },

    en: {
      // Main Navigation
      navigation: {
        english: "Trivia",
        stories: "Stories",
        grammar: "Grammar", 
        verbs: "Verbs",
        quiz: "Quiz",
        about: "About",
        portfolio: "Portfolio",
        contact: "Contact"
      },

      // English Section
      english: {
        title: "COMPLETE ENGLISH GRAMMAR GUIDE",
        subtitle: "Click on \"View Examples\" to expand each topic",
        description: "Keep practicing to master English!",
        features: [
          "Grammar structured by categories",
          "Complete list of irregular verbs", 
          "Interactive exercises",
          "Practical examples",
          "Personal progress tracking"
        ],
        startButton: "Start Course",
        learnMoreButton: "Learn More"
      },

      // Grammar Section
      grammar: {
        title: "English Grammar",
        subtitle: "Learn the fundamental rules of English",
        description: "Explore different grammar categories with practical examples and clear explanations.",
        searchPlaceholder: "Search grammar topic...",
        noResultsFound: "No results found",
        examplesButton: "View Examples",
        backButton: "Back",
        examples: "Examples"
      },

      // Verbs Section
      verbs: {
        title: "Irregular Verbs",
        subtitle: "Master the most important irregular verbs",
        description: "Complete list of irregular verbs with pronunciation and usage examples.",
        searchPlaceholder: "Search verb...",
        headers: {
          infinitive: "Infinitive",
          pastSimple: "Past Simple",
          pastParticiple: "Past Participle", 
          translation: "Translation"
        },
        showAll: "Show All",
        showLess: "Show Less"
      },

      // Quiz Section
      quiz: {
        title: "Test Your Knowledge",
        subtitle: "Evaluate your progress with our interactive quizzes",
        description: "Test what you've learned with grammar and vocabulary exercises.",
        startQuiz: "Start Quiz",
        nextQuestion: "Next Question",
        previousQuestion: "Previous Question",
        finishQuiz: "Finish Quiz",
        restartQuiz: "Restart Quiz",
        backToMenu: "Back to Menu",
        question: "Question",
        of: "of",
        score: "Score",
        results: "Results",
        correct: "Correct",
        incorrect: "Incorrect",
        percentage: "Percentage",
        feedback: {
          excellent: "Excellent! You master the topic very well.",
          good: "Well done! You're on the right track.",
          needsPractice: "You need more practice. Keep studying!",
          keepTrying: "Don't give up! Practice makes perfect."
        }
      },

      // Stories Section
      stories: {
        title: "My Stories",
        subtitle: "Personal collection of epic and fantastic tales",
        description: "Explore worlds of fantasy, romance and adventure created with passion",
        loading: "Loading stories...",
        backToStories: "Back to Stories",
        readStory: "Read Story",
        moreStories: "More stories coming soon...",
        author: "Author",
        status: "Status",
        chapters: "Chapters",
        tags: "Tags",
        lastUpdated: "Last updated",
        chapterEnd: "End of available chapter",
        createdWithLove: "Story created with love by",
        totalStories: "Total stories",
        totalChapters: "Total chapters",
        statusOptions: {
          inProgress: "In progress",
          completed: "Completed",
          draft: "Draft"
        }
      },

      // About Section  
      about: {
        title: "About the Project",
        subtitle: "Full Stack Developer & Educational App Creator",
        description: "This English Grammar application is one of my web development projects, designed to showcase my skills in creating interactive educational applications. As a freelance developer, I specialize in creating similar projects for clients.",
        features: {
          title: "Project Features",
          items: [
            {
              title: "Full Stack Development",
              description: "Complete application built with React and advanced functionalities"
            },
            {
              title: "Interactive Interface", 
              description: "Modern UI/UX with dynamic and responsive components"
            },
            {
              title: "Complete Functionality",
              description: "Quiz system, intuitive navigation and data management"
            },
            {
              title: "Scalable Code",
              description: "Modular and maintainable architecture for future expansions"
            }
          ]
        },
        objectives: {
          title: "Development Objectives",
          items: [
            "Demonstrate development capabilities in React and JavaScript",
            "Create an exceptional user experience",
            "Implement complex educational functionalities", 
            "Showcase software design and architecture skills"
          ]
        },
        methodology: {
          title: "Development Process",
          description: "My approach combines modern web development best practices, using current technologies and agile methodologies to create robust and scalable projects."
        }
      },

      // Portfolio Section
      portfolio: {
        title: "My Portfolio",
        subtitle: "Discover my experience and projects",
        navigation: {
          home: "Home",
          about: "About",
          experience: "Experience",
          projects: "Projects", 
          services: "Services",
          skills: "Skills",
          contact: "Contact"
        },
        hero: {
          greeting: "Hello! I'm",
          profession: "Full Stack Developer | Drupal Specialist",
          description: "Systems Engineer with a proven track record of delivering successful projects for clients worldwide. Specialized in Drupal development for universities, digital agencies, and organizations across the United States.",
          ctaButton: "View Projects",
          contactButton: "Contact"
        },
        about: {
          title: "About Me",
          description: "Systems Engineer with years of specialized experience in Drupal development. I have successfully built and maintained complex web solutions for universities, digital agencies, and various organizations. My technical expertise spans multiple frameworks including React, Angular, Node.js, WordPress, and ASP.NET, but Drupal remains one of my core strengths with deep expertise in custom module development, theming, and enterprise-level implementations.",
          downloadCV: "Download CV",
          stats: {
            experience: "Years of Experience",
            projects: "Completed Projects",
            clients: "Satisfied Clients",
            technologies: "Technologies Mastered"
          }
        },
        experience: {
          title: "Experience",
          subtitle: "My professional journey",
          workTab: "Work",
          educationTab: "Education",
          present: "Present",
          achievements: "Achievements"
        },
        projects: {
          title: "Projects",
          subtitle: "Some of my featured work",
          viewProject: "View Project",
          viewCode: "View Code",
          technologies: "Technologies",
          status: "Status",
          type: "Type",
          showMore: "View all projects",
          showLess: "Show less",
          ctaTitle: "Do you have a project in mind?",
          ctaDescription: "I'd love to hear your idea and help you make it a reality. Let's work together!",
          contactButton: "Contact"
        },
        services: {
          title: "Services", 
          subtitle: "Professional solutions for your business",
          price: "Price",
          deliveryTime: "Delivery Time",
          features: "Features",
          technologies: "Technologies",
          contactService: "Contact",
          whatsappContact: "Contact via WhatsApp"
        },
        skills: {
          title: "Skills",
          subtitle: "Technologies I master",
          categories: {
            frontend: "Frontend",
            backend: "Backend",
            database: "Database",
            tools: "Tools",
            design: "Design"
          }
        },
        contact: {
          title: "Contact",
          subtitle: "Let's work together!",
          description: "Do you have a project in mind? I'd love to hear your idea and help you make it a reality.",
          info: {
            title: "Contact Information",
            email: "Email",
            whatsapp: "WhatsApp", 
            location: "Location",
            availability: "Availability"
          },
          form: {
            title: "Send me a message",
            name: "Name",
            email: "Email",
            subject: "Subject",
            message: "Message",
            namePlaceholder: "Your name",
            emailPlaceholder: "your@email.com",
            messagePlaceholder: "Tell me about your project...",
            selectSubject: "Select a subject",
            subjects: {
              webDev: "Web Development",
              consulting: "Consulting",
              collaboration: "Collaboration",
              other: "Other"
            },
            sendButton: "Send via WhatsApp",
            required: "Required field"
          },
          social: {
            title: "Social Media",
            description: "Follow me on social media"
          },
          quickContact: {
            title: "Prefer direct contact?",
            whatsapp: "WhatsApp",
            email: "Email",
            emailSubject: "Inquiry about development services",
            whatsappMessage: "Hi! I'm interested in your web development services."
          },
          location: "Location",
          email: "Email",
          services: {
            title: "Available Services",
            items: [
              "Full Stack Web Development",
              "React & Angular Applications",
              "Laravel & ASP.NET Projects", 
              "WordPress & Drupal Development",
              "Educational Platforms",
              "Technical Consulting"
            ]
          }
        },
        nav: {
          home: "Home",
          about: "About",
          projects: "Projects",
          skills: "Skills",
          experience: "Experience",
          services: "Services",
          contact: "Contact",
          portfolio: "Portfolio",
          company: "Company",
          englishCourse: "English Course"
        },
        footer: {
          description: "Full-Stack developer specialized in creating exceptional web experiences. I transform ideas into innovative digital solutions.",
          profession: "Full-Stack Developer",
          follow: "Follow me on",
          quickLinks: "Quick Links",
          technicalConsulting: "Technical Consulting",
          rights: "All rights reserved",
          privacy: "Privacy",
          terms: "Terms",
          cookies: "Cookies",
          builtWith: "Built with"
        },
        services: {
          title: "Services",
          subtitle: "How can I help you?",
          webDevelopment: "Web Development",
          frontend: "Frontend Development",
          backend: "Backend Development",
          fullstack: "Full-Stack Development",
          ecommerce: "E-commerce",
          features: "Includes",
          technologies: "Technologies",
          contactService: "Contact",
          deliveryTime: "Delivery Time"
        }
      },

      // Common messages
      common: {
        loading: "Loading...",
        error: "Error",
        success: "Success", 
        cancel: "Cancel",
        confirm: "Confirm",
        close: "Close",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        search: "Search",
        filter: "Filter",
        reset: "Reset",
        showMore: "Show more",
        showLess: "Show less",
        noResults: "No results found",
        tryAgain: "Try again"
      },

      // Authentication
      auth: {
        title: "Restricted Access",
        subtitle: "This section requires authentication to access",
        passwordLabel: "Password:",
        passwordPlaceholder: "Enter password",
        submitButton: "Access",
        logoutButton: "Logout",
        incorrectPassword: "Incorrect password",
        privateSection: "Private section for personal use"
      }
    }
  },

  // Datos que no cambian con el idioma
  personal: {
    name: "Anthony Marín Bolívar",
    email: "anthonymmarinbolivar@gmail.com",
    phone: "+506 8371-4550",
    whatsapp: "https://wa.me/+50683714550",
    location: {
      city: "Cañas",
      state: "Guanacaste", 
      country: "Costa Rica",
      full: "Cañas, Guanacaste, Costa Rica"
    },
    availability: "Lun - Vie: 8:00 AM - 6:00 PM"
  },

  social: [
    {
      platform: "GitHub",
      url: "https://github.com/AnthonyDaniel",
      icon: "💻"
    },
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/thony1199/",
      icon: "💼"
    },
    {
      platform: "Portfolio",
      url: "https://soy-thony.web.app/",
      icon: "🌐"
    },
    {
      platform: "Facebook",
      url: "https://www.facebook.com/thony1199/",
      icon: "📘"
    }
  ],

};

// Configuración por defecto
export const defaultLanguage = 'es';
export const availableLanguages = ['es', 'en'];

export default appData;
